import { officePathByBrand } from '@aspendental/shared-components-web';
import { convertNameToUrlFormat } from '@aspendental/shared-components-web/lib/utils/convertNameToUrlFormat/convertNameToUrlFormat';

export const generateProviderSchemaObject = (config: any, doctorDetails: any, path: any) => {
	const { siteURL, features } = config as BrandThemeConfig;
	const { firstName, lastName } = doctorDetails.provider;
	const mainFacilityLocation = doctorDetails.provider.providerLocations?.find(({ isMain }) => isMain);

	const address1 = mainFacilityLocation?.facility?.location?.address1;
	const city = mainFacilityLocation?.facility?.location?.city;
	const stateCode = mainFacilityLocation?.facility?.location?.stateCode;
	const zipCode = mainFacilityLocation?.facility?.address?.zipCode;
	const fullAddress = `${address1 || ''}, ${city || ''}, ${stateCode || ''} ${zipCode || ''}`;
	const googleMapsUrl = mainFacilityLocation
		? config.googleMapBusinessQuery.replace(/\[address\]/gi, `${fullAddress}`)
		: '';

	const officeDetailsUrl = `${siteURL}/${features.otherApps.facilityDetailsBasePath}/${officePathByBrand(
		config.themeId,
		{
			stateStrOptions: {
				stateAbbreviation: stateCode || '',
				state: '',
				city: city || '',
			},
			cityAddressOptions: {
				city: city ?? undefined,
				address: address1 ?? undefined,
				zip: zipCode ?? undefined,
			},
		}
	)}/`;

	const providerDetailsUrl = `${siteURL}${features.providers.root}${convertNameToUrlFormat(
		`${firstName} ${lastName}`
	)}${path}`;

	const schemaObject: {
		[key: string]: string[] | object | boolean | number | string;
	} = {
		'@context': 'https://schema.org',
		name: `${firstName} ${lastName}, ${doctorDetails.provider.degreeName || ''}`,
		image: doctorDetails.providerPicByNpi?.[0]?.url || '',
		description: doctorDetails.provider.biography || '',
		hasCredential: {
			'@type': 'EducationalOccupationalCredential',
			name: doctorDetails.provider.degreeName || '',
		},
		url: providerDetailsUrl ?? '',
		usNPI: doctorDetails.provider.npi,
		isAcceptingNewPatients: true,
	};

	if (mainFacilityLocation) {
		schemaObject.practicesAt = {
			name: `${config.name} ${mainFacilityLocation?.facility?.name || ''}`,
			url: officeDetailsUrl ?? '',
			address: {
				'@type': 'PostalAddress',
				streetAddress: address1 || '',
				addressLocality: city || '',
				addressRegion: stateCode || '',
				postalCode: zipCode || '',
				addressCountry: 'US',
			},
			hasMap: googleMapsUrl,
			geo: {
				'@type': 'GeoCoordinates',
				latitude: mainFacilityLocation?.facility?.location?.latitude || '',
				longitude: mainFacilityLocation?.facility?.location?.longitude || '',
			},
			telephone: mainFacilityLocation?.facility?.technicalInfrastructure?.phoneNumber || '',
			email: mainFacilityLocation?.facility?.technicalInfrastructure?.email || '',
		};

		if (features?.providerSchema?.practicesAt?.['@type']) {
			schemaObject.practicesAt['@type'] = features.providerSchema.practicesAt['@type'];
		}
	}

	if (features?.providerSchema?.['@type']) {
		schemaObject['@type'] = features.providerSchema['@type'];
	}

	if (features?.providerSchema?.medicalSpecialty) {
		schemaObject.medicalSpecialty = features.providerSchema.medicalSpecialty;
	}

	return schemaObject;
};
